export default "__VITE_ASSET__38766dc5__"